import { Component, Input } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import {FinalUserRestService} from "../../../providers/final-user-restservice";

@Component({
  selector: "app-deleteuser-modal",
  templateUrl: "./deleteuser-modal.component.html",
  styleUrls: ["./deleteuser-modal.component.scss"],
})
export class DeleteuserModalComponent {

  @Input() responses: any = null;
  numbers: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  userid: number;
  constructor(
    public modalRef: MdbModalRef<DeleteuserModalComponent>,
    private _finalUserService : FinalUserRestService,
  ) {}

  setId(finalUserId: any) {
    this.userid = finalUserId;
  }
  deleteuser() {
    this._finalUserService.deleteFinalUser(this.userid).subscribe((result: any) => {
      this.modalRef.close()
      document.getElementById('userid_' + this.userid).remove();
    })
  }

  setResponses(responses: any){
    if (responses.length > 0){
      this.responses = responses;
    }
  }
}